<template>
  <div id="slide-3" class="slide pt-37.5 px-23.5 h-screen">
    <div class="relative flex flex-col gap-12.5" style="height: max-content">
      <div class="about  gap-12.5 flex flex-col font-medium">
        <p
          class="uppercase fz-10"
          style="color: rgba(110, 117, 141, 1); letter-spacing: 0.3em;"
        >
          {{ text.miniTitle }}
        </p>
        <p
          class="fz-20  main text-justify"
          style="line-height: 2.25rem"
        >
          {{text.mainText}}
        </p>
        <div class="flex justify-end gap-5">
          <img
            class="w-auto"
            src="@/assets/images/slide_2/about/team.svg"
            alt=""
          />
          <img
            class="w-auto"
            src="@/assets/images/slide_2/about/thunder.svg"
            alt=""
          />
        </div>
      </div>
      <div class="flex flex-col gap-16.5">
        <span
            class="fz-10 ml-0.5 font-medium color-accent uppercase"
            style="line-height: 1; letter-spacing: 0.3rem"
        >{{ text.ready }}</span
        >
        <slider
            :slides-container-classes="'mb-12.5 gap-7.5'"
            :slider-classes="'w-full relative tablet-products-slider'"
            :similar-slides="true"
            :pagination="true"
            pagination-container-classes="gap-5"
        >
          <template v-slot:slides>
            <div
                class="slider-slide w-62.5 flex flex-col"
                v-for="item in text.stackSlider"
                :key="item"
            >
              <img
                  :src="
              require('@/assets/images/slide_2/stack/' + item.image + '.svg')
            "
                  class="h-19 w-19 p-4.5 rounded-full mb-5"
                  style="background: rgba(110, 117, 141, 0.2)"
                  alt=""
              />
              <p class="fz-16 font-medium" style="line-height: 1.5625rem">
                {{ item.text }}
              </p>
            </div>
          </template>
          <template v-slot:pagination>
            <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
          </template>
        </slider>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import slider from "@/components/tablet/reuseable/slider";


export default {
  name: "slide3",
  components:{slider},
  data() {
    return {
      stackState: 0,
      stackDirection: "stack-up"
    };
  },
  computed:{
    text(){
      return require("@/assets/text/main/slide2/" + this.lang + ".json")
    },
    ...mapState(['lang'])
  },
  methods: {
    stackNext() {
      if (this.stackState < this.text.stackSlider.length - 3) {
        this.stackState++;
      }
    },
    stackPrev() {
      if (this.stackState > 0) {
        this.stackState--;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.about > .main {
  text-indent: 11.25rem;
}

.slide-2 {
  .header {
    .icons {
      svg {
        width: 2.5rem;
      }
    }
  }
}

.pagination {
  transition: all linear 0.3s;
  background: #fff;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}

.tablet-products-slider::before, .tablet-products-slider::after{
  z-index: 87;
  content: '';
  position: absolute;
  height: 100%;
  width: 5.875rem;
  top: 0;
  bottom: 0;
  background: linear-gradient(270deg, #020306 0%, rgba(2, 3, 6, 0) 100%);
}
.tablet-products-slider::before{
  right: 100%;
  transform: rotate(-180deg);
}
.tablet-products-slider::after{
  left: 100%;
}
</style>
